import React, { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import {
  getProviderItemCategories,
  getProviderItems,
} from "store/provider-dashboard/provider-dashboard-action"
import AdjustmentForm from "components/Adjustment/form"
import { storeAdjustments } from "store/adjustment/adjustment-action"

const AddAdjustment = () => {
  document.title = "Add Adjustment"
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { loading, error } = useSelector(state => state.adjustment)
  const categories = useSelector(
    state => state.providerDashboard.ProviderItemCategoires
  )
  const items = useSelector(state => state.providerIn.items)

  const handleSubmit = (rows, file) => {
    const formData = new FormData()
    formData.append("document", file)
    formData.append("adjustments", JSON.stringify(rows))
    dispatch(storeAdjustments(formData, navigate))
  }

  useEffect(() => {
    dispatch(getProviderItemCategories())
  }, [])

  return (
    <AdjustmentForm
      onSubmit={handleSubmit}
      loading={loading}
      error={error}
      formMode={"Add"}
      categories={categories?.data}
      items={items?.data || []}
    />
  )
}

export default AddAdjustment
